export const OPPORTUNITIES_TYPES = 'SMALL_EFFORT'
